import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { TooltipProvider } from '@/components/ui/tooltip';
import { createQueryClient } from '@/lib/query-client';
import { router } from '@/lib/router';
import { applyTheme, watchSystemTheme } from '@/lib/theme';
import { useThemeStore } from '@/store/theme-store';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root is missing from index.html.');
}

const queryClient = createQueryClient();

// theme-init.js already stamped this before the first paint; re-applying keeps the DOM in step with the
// store when the two could disagree (a stale attribute after HMR, a second tab writing the preference).
applyTheme(useThemeStore.getState().resolved);

// A session left on "System" follows the machine going dark without needing a reload. Registered at the
// composition root rather than inside the toggle: it must hold for the whole app, not for one control.
watchSystemTheme(() => {
  useThemeStore.getState().syncWithSystem();
});

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={200}>
          <RouterProvider router={router} />
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
